import { styled } from 'stitches.config'
import { BorderWave } from 'components/BorderWave'

export const TimelineRoot = styled('div', {
  width: '100%',
  background: '$tertiary-200',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '@bp3': {
    paddingBottom: '$3',
  },
})

export const BannerText = styled('h2', {
  position: 'relative',
  width: '290px',
  fontSize: '$h2',
  textAlign: 'center',
  fontWeight: '$medium',
  color: '$tertiary-200',

  '@bp2': {
    fontSize: '$h1',
    width: '100%',
  },
})

export const BannerWrapper = styled('div', {
  position: 'relative',
  width: '100%',
  background: '$primary-500',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '228px',
  paddingTop: '38px',
  zIndex: 1,

  '@bp2': {
    height: '240px',
    padding: 0,
  },
})

export const Subtitle = styled('h4', {
  width: '100%',
  maxWidth: '320px',
  paddingTop: '35px',
  paddingBottom: '8px',
  textAlign: 'center',
  fontWeight: '$medium',
  color: '$primary-500',
  fontSize: '$h4',
  '@bp2': {
    maxWidth: '620px',
    paddingBottom: 0,
    paddingTop: '32px',
  },
})

export const HappyDogWrapper = styled('div', {
  width: '500px',
  position: 'static',
  transform: 'translateX(50px)',

  '@bp2': {
    position: 'relative',
  },

  '@bp3': {
    width: '700px',
    position: 'absolute',
    transform: 'translateX(-380px)',
  },

  '@bp4': {
    width: '820px',
    transform: 'translateX(-460px)',
  },
})

export const TimelineWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
  zIndex: '1',
  height: '732px',
  width: '300px',
  '@bp1': {
    width: '370px',
  },
  '@bp2': {
    gap: '$7',
    height: 'auto',
    width: '500px',
    transform: 'translateX(0px)',
  },
  '@bp3': {
    width: '500px',
    transform: 'translateX(100px)',
  },
})

export const WeekWrapper = styled('div', {
  position: 'absolute',
  width: '100%',
  maxWidth: '360px',
  display: 'flex',
  flexDirection: 'column',
  left: '60px',
  right: '0px',

  '@bp1': {
    left: '60px',
  },

  '@bp2': {
    left: '40px',
    maxWidth: 'none',
    width: '720px',
  },

  variants: {
    num: {
      '1': {
        top: '-9px',
        '@bp2': {
          top: '-10px',
        },
      },
      '2': {
        top: '177px',
        '@bp2': {
          top: '158px',
        },
      },
      '3': {
        top: '368px',
        '@bp2': {
          top: '318px',
        },
      },
      '4': {
        top: '530px',
        '@bp2': {
          top: '471px',
        },
      },
    },
  },
})

export const ArrowWrapper = styled('div', {
  width: '30px',
  display: 'none',
  '@bp2': { display: 'block' },
})

export const RedLineWrapper = styled('div', {
  display: 'block',
  width: '42px',
  '@bp2': { display: 'none' },
})

export const SectionWrapper = styled('div', {
  paddingTop: '92px',
  height: 'auto',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  flexDirection: 'column-reverse',
  alignItems: 'center',

  '@bp3': {
    height: '900px',
    flexDirection: 'row',
    paddingTop: '56px',
  },
})

export const BadgeWrapper = styled('div', {
  position: 'absolute',
  zIndex: 2,
  top: '60px',
  left: 0,
  right: 0,
  display: 'none',
  '@bp3': { display: 'block', transform: 'translateX(-500px)' },
  '@bp4': { transform: 'translateX(-600px)' },
})

export const SubHead = styled('p', {
  fontWeight: '$medium',
  fontSize: '$bodyExtraLarge',
  color: '$accent-black',

  '@bp2': {
    fontSize: '$bodyExtraLarge',
  },

  variants: {
    desktopOnly: {
      true: {
        display: 'none',
        '@bp2': { display: 'block' },
      },
    },
    mobileOnly: {
      true: {
        display: 'block',
        '@bp2': { display: 'none' },
      },
    },
    align: {
      center: { textAlign: 'center' },
      start: {
        textAlign: 'center',
        position: 'absolute',
        left: 0,
        right: '58px',
        top: '32px',
      },
    },
  },
})

export const Result = styled(SubHead, {
  fontSize: '$h5',
  fontWeight: '$regular',

  '@bp2': {
    fontSize: '$h5',
  },
})

export const DesktopBorderWave = styled(BorderWave, {
  display: 'none',
  '@bp2': {
    display: 'block',
  }
})

export const MobileBorderWave = styled(BorderWave, {
  display: 'block',
  '@bp2': {
    display: 'none',
  }
})
